// The relay command (D80): the IdP posts the SAML response to http://127.0.0.1:35001 on the
// user's computer; this listens there with built-in tools and forwards the request to the
// one-time callback on OpenCloudSecurity. Two variants:
// - `nc`: OpenBSD netcat (macOS's `nc`, Ubuntu's default) sends the canned page to the
//   browser at once, so the browser closes its side, `nc` ends and `curl` posts everything
//   the browser sent (the raw request; the API takes SAMLResponse out of its body).
// - `python3`: waits for the POST itself (ignoring stray requests such as a favicon),
//   forwards only its body, and shows the browser OpenCloudSecurity's answer.
// Both were checked against a local listener with a 17 KB form body (S102).

/** Single-quoted for a POSIX shell. */
function shellQuote(text: string): string {
  return `'${text.replace(/'/g, `'\\''`)}'`;
}

const PAGE = "Signed in. You can close this tab now.\n";

export function ncCommand(url: string): string {
  const reply = `HTTP/1.1 200 OK\\r\\nContent-Type: text/plain\\r\\nContent-Length: ${PAGE.length}\\r\\nConnection: close\\r\\n\\r\\n${PAGE.replace("\n", "\\n")}`;
  return `printf ${shellQuote(reply)} | nc -l 127.0.0.1 35001 | curl -sS --data-binary @- ${shellQuote(url)}`;
}

const PYTHON = [
  "import http.server as h,urllib.request as u,urllib.error as e,sys",
  "class H(h.BaseHTTPRequestHandler):",
  " def do_POST(s):",
  '  b=s.rfile.read(int(s.headers.get("Content-Length",0)))',
  "  try:t=u.urlopen(u.Request(sys.argv[1],b)).read()",
  "  except e.HTTPError as x:t=x.read()",
  '  s.send_response(200);s.send_header("Content-Type","text/plain");s.end_headers();s.wfile.write(t);print(t.decode().strip());s.server.done=1',
  " def log_message(s,*a):pass",
  'v=h.HTTPServer(("127.0.0.1",35001),H);v.done=0',
  "while not v.done:v.handle_request()",
].join("\n");

export function pythonCommand(url: string): string {
  return `python3 -c ${shellQuote(PYTHON)} ${shellQuote(url)}`;
}

/** The full callback URL on this origin. */
export function callbackUrl(origin: string, callbackPath: string): string {
  return new URL(callbackPath, origin).toString();
}
